module.exports = __webpack_public_path__ + "img/sld_battery_2_dark.cf0da6ed.svg";